import s from './BaseModal.module.css';

const Modal = ({isOpen, onClose, height= "30rem", width="40rem", children }) => {

    // IF CLICK OUTSIDE MODAL, CLOSE IT
    const handleClickOutside = (e) => {
        // if you clicked exactly on the backdrop (not on any child)
        if (e.target.classList.contains(s.modalBackdrop)) {
            onClose();
        }
    };

    return ( 
<div className={s.modalBackdrop} onClick={handleClickOutside}>
    <div className={s.modalContent} style={{...(height && { height }),...(width && { width }),}}>
        <div className={s.closeButton} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        </div>
        {children}
    </div> 
</div>
    );
}
 
export default Modal;